import { motion } from "framer-motion";
import "../styles/ElevateHero.css";

export default function HeroSection() {
  return (
    <section className="Elevator-hero-section">
      <div className="Elevator-overlay">
        <motion.div
          className="Elevator-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          {" "}
          <h1 className="herosection-title">
            <span className="herosection-main-title">Nexa</span>
            <span className="herosection-subtitle"> Elevate</span>
          </h1>
        </motion.div>
      </div>
    </section>
  );
}
